<div class="tw-block tw-border-spacing-0 tw-w-full tw-flex-[1] tw-overflow-hidden tw-h-screen tw-font-body">
  <loading id="loading" class="tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2" *ngIf="isLoading$ | async"></loading>
  <div class="tw-flex tw-flex-col tw-flex-[1] tw-h-full">
    <div class="tw-w-full tw-flex-initial">
      <div class="tw-bg-black tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100]">
        <div class="tw-absolute tw-top-2 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" [class]="acqRebranding2025 ? 'tw-left-[15px]' : 'tw-left-6'" (click)="back()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
        </div>
        <span class="tw-text-300 tw-text-white" *ngIf="!isShiprocketFlow && hasAnyAddress" [class]="acqRebranding2025 ? 'tw-font-lexend tw-font-normal' : 'tw-font-body tw-font-bold'" i18n="@@selectAddress">Delivery address</span>
        <ng-container *ngIf="isShiprocketFlow && hasAnyAddress">
          <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal" *ngIf="(addressBookList$ | async)?.length === 1" i18n="@@addressFound">{{ (addressBookList$ | async)?.length }} Address Found</span>
          <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal" *ngIf="(addressBookList$ | async)?.length > 1" i18n="@@addressesFound">{{ (addressBookList$ | async)?.length }} Addresses Found</span>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="!(isLoading$ | async)">
      <div class="ld-session-block tw-w-full tw-flex-auto tw-overflow-y-auto tw-overflow-x-hidden tw-bg-gray-100"
           [ngClass]="{
             'tw-pb-[160px]': hasAnyAddress && (isShiprocketFlow || acqRebranding2025),
             'tw-pb-0': !hasAnyAddress
           }"
      >
        @if (acqRebranding2025 || isShiprocketFlow) {
          <div id="addAddressRebranded"
               *ngIf="!(isLoading$ | async) && !loading"
               class="tw-flex tw-items-center tw-justify-start tw-gap-2 tw-mb-[14px] tw-text-300 tw-p-5 tw-pt-[16.5px] tw-pb-[18.5px]"
               [class.tw-bg-gray-50]="shouldShowAddressSectionHeaders"
               (click)="addNewAddressClick()"
              >
            <span class="tw-font-lexend tw-font-semibold tw-text-300 tw-text-teal-600 tw-capitalize" i18n="@@addNewAddress">Add new address</span>
            <em class="cs-icon-plus tw-w-4 tw-h-4 tw-text-teal-700"></em>
          </div>
        } @else {
        <div class="tw-bg-gray-50 tw-p-5 tw-flex tw-items-center tw-border tw-border-gray-200 tw-rounded tw-justify-start tw-uppercase tw-mb-5 tw-text-300 tw-shadow-z1" id="addAddress" *ngIf="!(isLoading$ | async) && !loading" (click)="addNewAddressClick()">
          <em class="cs-icon-plus"></em>
          <span class="tw-pl-2 tw-font-body tw-normal-case" i18n="@@addNewAddress">Add new address</span>
        </div>
        }
        <div *ngIf="(defaultAddress$ | async) && !isShiprocketFlow && shouldShowAddressSectionHeaders"
             class="tw-pt-0 tw-uppercase"
             [class]="acqRebranding2025 ? 'tw-font-lexend tw-text-gray-500 tw-text-100 tw-pb-2 tw-pl-6 tw-pr-4' : 'tw-font-body tw-tracking-wide tw-text-200 tw-pb-5 tw-px-4'"
             i18n="@@defaultAddress"
        >
          Default address
        </div>
        <ng-container *ngIf="defaultAddress$ | async as defaultAddress">
          <div class="tw-mt-0 tw-mb-5 tw-relative tw-rounded tw-overflow-hidden"
               [ngClass]="{
                 'tw-mx-6 tw-rounded-2': acqRebranding2025,
                 'tw-mx-4': !acqRebranding2025,
                 'tw-bg-white tw-shadow-z1': shouldShowCardHighlight(defaultAddress)
               }"
               >
            @if (acqRebranding2025) {
              <div class="tw-py-4 tw-pl-2 tw-pr-5 tw-font-lexend tw-font-normal">
                <radio-btn cssClass="tw-shrink-0" contentCssClass="tw-flex tw-flex-col tw-overflow-auto" [checked]="deliverTo?.objectId === defaultAddress.objectId" (checkedChange)="deliverTo = defaultAddress">
                  <div class="tw-capitalize tw-break-words" *ngIf="defaultAddress?.contactName">
                    {{ defaultAddress?.contactName}},
                  </div>
                  <div class="tw-text-300 tw-break-words" *ngIf="defaultAddress?.userEmail">
                    {{ defaultAddress?.userEmail }}
                  </div>
                  <div id="defaultAddressRebranded" class="tw-text-300 tw-capitalize tw-break-words">
                    {{ getDeliveryAddress(defaultAddress)}}
                  </div>
                  <div *ngIf="!internalUser" class="tw-text-300 tw-break-words"> +91-{{ defaultAddress.mobileNumber || defaultAddress.alternateNumber }}
                  </div>
                </radio-btn>
                <hr class="tw-ml-[26px] tw-mt-2" *ngIf="!isFromReviewOrder || isSelectedAddress(defaultAddress)"/>
                <div *ngIf="shouldShowDeliveryDate(defaultAddress)" class="tw-ml-[26px] tw-mt-2">
                  <app-expected-delivery-date
                    [expectedDeliveryDate]="deliveryDate"
                    [dayDifference]="deliveryDayDiff"
                    [variant]="DELIVERY_DATE_VARIANT.BADGE"
                  />
                </div>
                <div class="tw-flex tw-w-full tw-ml-[26px]" *ngIf="!isFromReviewOrder || isSelectedAddress(defaultAddress)">
                  <span id="defaultAddressEditButtonRebranded" class="tw-text-teal-600 tw-font-semibold tw-text-300 tw-pt-[14px] tw-pb-[6px] tw-px-0" i18n="@@edit" (click)="editAddress(defaultAddress)">Edit</span>
                  <span id="defaultAddressDeleteButtonRebranded" class="tw-text-teal-600 tw-font-semibold tw-text-300 tw-pt-[14px] tw-pb-[6px] tw-px-0 tw-ml-8" i18n="@@delete" (click)="deleteAddress(defaultAddress)">Delete</span>
                </div>
              </div>
            } @else {
          <div class="tw-py-5 tw-px-4">
            <radio-btn cssClass="tw-shrink-0" contentCssClass="tw-flex tw-flex-col tw-overflow-auto" [checked]="deliverTo?.objectId === defaultAddress.objectId" (checkedChange)="deliverTo = defaultAddress">
              <div class="tw-capitalize tw-mb-1 tw-text-400 tw-leading-none tw-break-words">{{defaultAddress.tag}}</div>
              <div class="tw-capitalize tw-break-words" *ngIf="defaultAddress?.contactName">
                {{ defaultAddress?.contactName}},
              </div>
              <div class="tw-text-300 tw-break-words" *ngIf="defaultAddress?.userEmail">
                {{ defaultAddress?.userEmail }}
              </div>
              <div id="defaultAddress" class="tw-text-300 tw-capitalize tw-break-words">
                {{ getDeliveryAddress(defaultAddress)}}
              </div>
              <div *ngIf="!internalUser" class="tw-text-300 tw-break-words"> +91-{{ defaultAddress.mobileNumber || defaultAddress.alternateNumber }}
              </div>
            </radio-btn>
          </div>
          <div class="tw-flex tw-w-full tw-bg-gray-100" *ngIf="!isFromReviewOrder || isSelectedAddress(defaultAddress)">
                <span id="defaultAddressEditButton" class="tw-w-1/2 tw-text-center tw-text-200 tw-py-2.5 tw-px-0" i18n="@@edit" (click)="editAddress(defaultAddress)">Edit</span>
                <span id="defaultAddressDeleteButton" class="tw-w-1/2 tw-text-center tw-text-200 tw-py-2.5 tw-px-0 tw-border-l tw-border-l-white" i18n="@@delete" (click)="deleteAddress(defaultAddress)">Delete</span>
              </div>
            }
          </div>
        </ng-container>
        <div *ngIf="(otherAddressList$ | async)?.length && !isShiprocketFlow && shouldShowAddressSectionHeaders"
             class="tw-uppercase"
             [class]="acqRebranding2025 ? 'tw-font-lexend tw-text-gray-500 tw-text-100 tw-leading-[21px] tw-pl-6 tw-pr-4 tw-pb-2' : 'tw-text-200 tw-font-body tw-tracking-wide tw-px-4 tw-pb-5'"
             i18n="@@otherAddress"
        > Other addresses </div>
        @if (acqRebranding2025 || isShiprocketFlow) {
          <div class="tw-mt-0 tw-mx-6 tw-mb-5 tw-relative tw-rounded-2 tw-font-lexend tw-font-normal tw-overflow-hidden"
               [ngClass]="{ 'tw-bg-white tw-shadow-z1': shouldShowCardHighlight(address) }"
               *ngFor="let address of (otherAddressList$ | async); let i = index">
            <div class="tw-pl-2 tw-pr-5 tw-py-4">
              <radio-btn cssClass="tw-shrink-0" contentCssClass="tw-flex tw-flex-col tw-overflow-auto" [checked]="deliverTo?.objectId === address.objectId" (checkedChange)="deliverTo = address">
                <div class="tw-capitalize tw-break-words">{{ address?.contactName }},</div>
                <div class="tw-text-300 tw-break-words" *ngIf="address?.userEmail">
                  {{ address?.userEmail }}
                </div>
                <div id="deliveryAddressRebranded" class="tw-text-300 tw-break-words">
                  {{ address.buildingDetails}}, {{ address.localityDetails}}, {{ address.landmark}}
                </div>
                <div class="tw-text-300 tw-break-words">
                  {{ address.city}}, {{ address.state}} - {{ address.zipCode}}
                </div>
                <div *ngIf="!internalUser" class="tw-text-300 tw-break-words"> +91-{{ address.mobileNumber || address.alternateNumber }}
                </div>
              </radio-btn>
              <hr *ngIf="isSelectedAddress(address)" class="tw-ml-[26px] tw-mt-2"/>
              <div *ngIf="shouldShowDeliveryDate(address)" class="tw-ml-[26px] tw-mt-2">
                <app-expected-delivery-date
                  [expectedDeliveryDate]="deliveryDate"
                  [dayDifference]="deliveryDayDiff"
                  [variant]="DELIVERY_DATE_VARIANT.BADGE"
                />
              </div>
              <div class="tw-flex tw-w-full tw-ml-[26px]" *ngIf="isSelectedAddress(address)">
                <span id="editButtonRebranded" class="tw-text-teal-600 tw-font-semibold tw-text-300 tw-pt-[14px] tw-pb-[6px] tw-px-0" i18n="@@edit" (click)="editAddress(address, i)">Edit</span>
                <span id="deleteButtonRebranded" class="tw-text-teal-600 tw-font-semibold tw-text-300 tw-pt-[14px] tw-pb-[6px] tw-px-0 tw-ml-8" i18n="@@delete" (click)="deleteAddress(address)">Delete</span>
              </div>
          </div>
        </div>
        } @else {
        <div class="tw-mt-0 tw-mx-4 tw-mb-5 tw-relative tw-rounded tw-overflow-hidden tw-bg-white tw-shadow-z1" *ngFor="let address of otherAddressList$ | async">
          <div class="tw-py-5 tw-px-4">
            <radio-btn cssClass="tw-shrink-0" contentCssClass="tw-flex tw-flex-col tw-overflow-auto" [checked]="deliverTo?.objectId === address.objectId" (checkedChange)="deliverTo = address">
              <div class="tw-capitalize tw-mb-1 tw-text-400 tw-leading-none tw-break-words">{{address.tag}}</div>
              <div class="tw-capitalize tw-break-words">{{ address?.contactName }},</div>
              <div class="tw-text-300 tw-break-words" *ngIf="address?.userEmail">
                {{ address?.userEmail }}
              </div>
              <div id="deliveryAddress" class="tw-text-300 tw-break-words">
                {{ address.buildingDetails}}, {{ address.localityDetails}}, {{ address.landmark}}
              </div>
              <div class="tw-text-300 tw-break-words">
                {{ address.city}}, {{ address.state}} - {{ address.zipCode}}
              </div>
              <div *ngIf="!internalUser" class="tw-text-300 tw-break-words"> +91-{{ address.mobileNumber || address.alternateNumber }}
              </div>
            </radio-btn>
          </div>
          <div class="tw-flex tw-w-full tw-bg-gray-100" *ngIf="deliverTo?.objectId === address.objectId">
            <span id="editButton" class="tw-w-1/2 tw-text-center tw-text-200 tw-py-2.5 tw-px-0" i18n="@@edit" (click)="editAddress(address)">Edit</span>
            <span id="deleteButton" class="tw-w-1/2 tw-text-center tw-text-200 tw-py-2.5 tw-px-0 tw-border-l tw-border-l-white" i18n="@@delete" (click)="deleteAddress(address)">Delete</span>
          </div>
        </div>
        }
      </div>
      <div *ngIf="isShiprocketFlow && !hasAnyAddress && !loading" class="tw-h-full tw-w-full tw-flex tw-justify-center tw-pt-28 tw-px-11 tw-bg-gray-100">
        <div class="tw-flex tw-flex-col tw-gap-4 tw-w-[273px]">
          <div>
            <img src="/assets/icons/no-location-icon.svg" class="tw-w-[86px] tw-aspect-square tw-mx-auto tw-mix-blend-multiply" alt="Powered By Shiprocket" />
          </div>
          <div class="tw-font-lexend tw-font-normal tw-text-center">
            <p class="tw-font-[700] tw-text-600 tw-px-6 tw-mb-2" i18n="@@unableToFetchSavedAddress">Sorry! We are not able to fetch any saved address</p>
            <p class="tw-text-gray-800 tw-text-300">
              <span i18n="@@numberLabel">Number:</span>
              <span> +91 {{ shiprocketPhone }}</span>
            </p>
          </div>
          <div>
            <div
              type="button"
              class="tw-w-full tw-rounded-3 tw-py-3 tw-text-500 tw-font-[600] tw-text-white tw-font-lexend tw-mx-0 tw-text-center tw-bg-teal-600 tw-mb-2"
              (click)="tryWithAnotherNumber()"
              i18n="@@tryWithAnotherNumber"
            >
              Try with another number
            </div>

            <div
              type="button"
              class="tw-w-full tw-rounded-3 tw-py-[11px] tw-text-500 tw-font-[600] tw-text-teal-600 tw-font-lexend tw-mx-0 tw-text-center tw-border-[1.3px] tw-border-teal-600"
              (click)="addAddressManually()"
              i18n="@@addAddressManually"
            >
              Add address manually
            </div>
          </div>
        </div>
      </div>
      <!-- Rebranded Continue CTA -->
      <div *ngIf="shouldShowRebrandedContinue" class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-flex-none tw-p-5 bg-white">
        <button csButton
                id="continueButtonRebranded"
                type="button"
                class="tw-w-full"
                [loading]="inProcess"
                [disabled]="!deliverTo?.objectId"
                (click)="isShiprocketFlow ? continueFromShiprocketFlow() : saveAsDeliveryAddress()"
                i18n="@@continue"
        >Continue</button>
        <img *ngIf="isShiprocketFlow" src="/assets/icons/poweredByShipRocket.png" class="tw-w-[150px] tw-mt-2 tw-mx-auto tw-mix-blend-multiply" alt="Powered By Shiprocket" />
      </div>

      <!-- Existing Continue CTA -->
      <div *ngIf="shouldShowExistingContinue" class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-flex-none tw-p-5 bg-white">
        <cs-button
          id="continueButton"
          [class]="'w100 primary'"
          [disabled]="!deliverTo?.objectId"
          (callback)="isShiprocketFlow ? continueFromShiprocketFlow() : saveAsDeliveryAddress()"
          [loading]="inProcess"
        >
          <cs-button-text i18n="@@continue">Continue</cs-button-text>
        </cs-button>
        <img *ngIf="isShiprocketFlow" src="/assets/icons/poweredByShipRocket.png" class="tw-w-[150px] tw-mt-2 tw-mx-auto tw-mix-blend-multiply" alt="Powered By Shiprocket" />
      </div>
    </ng-container>
  </div>
</div>
